var _circle, _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgExchangeSwapWalletImage(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 41,
    viewBox: "0 0 40 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20.5,
    r: 19.5,
    stroke: "#7120C8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.1111 20.5V16.9444H14.6666C14.1951 16.9444 13.743 16.7571 13.4096 16.4237C13.0762 16.0903 12.8889 15.6382 12.8889 15.1667C12.8889 14.1889 13.6889 13.3889 14.6666 13.3889H25.3333V16.9444",
    stroke: "#FBD365",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8889 15.1667V25.8334C12.8889 26.8111 13.6889 27.6111 14.6666 27.6111H27.1111V24.0556",
    stroke: "#FBD365",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.3333 20.5C24.8618 20.5 24.4096 20.6873 24.0762 21.0207C23.7428 21.3541 23.5555 21.8063 23.5555 22.2778C23.5555 23.2556 24.3555 24.0556 25.3333 24.0556H28.8889V20.5H25.3333Z",
    stroke: "#FBD365",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExchangeSwapWalletImage);
export default __webpack_public_path__ + "static/media/exchangeSwapWalletImage.3805ad23e828c3a7ba4f5c04ff5a5ef4.svg";
export { ForwardRef as ReactComponent };